"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserMenuEventId = void 0;
var UserMenuEventId;
(function (UserMenuEventId) {
    UserMenuEventId["ACTIVITY"] = "activity";
    UserMenuEventId["ACCOUNT"] = "account";
    UserMenuEventId["MY_ASSETS"] = "my_assets";
    UserMenuEventId["PROFILE"] = "profile";
    UserMenuEventId["SIGN_IN"] = "sign_in";
    UserMenuEventId["SIGN_OUT"] = "sign_out";
    UserMenuEventId["GUEST"] = "guest";
    UserMenuEventId["MARKETPLACE_AUTHORIZATIONS"] = "marketplace_authorizations";
    UserMenuEventId["DOWNLOAD"] = "download";
    UserMenuEventId["BALANCE"] = "balance";
})(UserMenuEventId = exports.UserMenuEventId || (exports.UserMenuEventId = {}));
